interface LogoJourguiProps {
  width?: number;
  height?: number;
  className?: string;
}

export function LogoJourgui({ width, height, className }: LogoJourguiProps) {
  return (
    <img
      src="/assets/images/logo_jourgui.png"
      alt="Jourgui Logo"
      width={width}
      height={height}
      style={{ width, height }}
      className={className}
    />
  );
}
